import { Lock, UserPlus } from "lucide-react";

const MODES = [
  { id: "login", label: "Sign in", icon: Lock },
  { id: "register", label: "Create account", icon: UserPlus },
];

export const AuthModeToggle = ({ mode, onChange }) => (
  <div className="grid grid-cols-2 gap-1 p-1 rounded-xl bg-zinc-900/80 border border-zinc-800" role="tablist" data-testid="auth-mode-toggle">
    {MODES.map(({ id, label, icon: Icon }) => {
      const active = mode === id;
      return (
        <button
          key={id}
          type="button"
          role="tab"
          aria-selected={active}
          onClick={() => onChange(id)}
          data-testid={`auth-mode-${id}`}
          className={`flex items-center justify-center gap-2 py-2.5 rounded-lg text-sm font-semibold transition-colors ${
            active ? "bg-purple-600 text-white shadow" : "text-zinc-400 hover:text-white hover:bg-zinc-800/60"
          }`}
        >
          <Icon className="w-4 h-4" />
          {label}
        </button>
      );
    })}
  </div>
);
